import { BaseError } from '../lang/BaseError';

export abstract class ValidationError extends BaseError {
}
